// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ConsentUploadForm__wrapper__2u6Xf","submitResult":"ConsentUploadForm__submitResult__3Seoj","actionWrapper":"ConsentUploadForm__actionWrapper__Q-9VR","wrapper2faOptions":"ConsentUploadForm__wrapper2faOptions__3VOo0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SettingsConsent/ConsentUploadForm/ConsentUploadForm.css
// module id = 2990
// module chunks = 0